import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=9fc22d2e&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"
import style0 from "./Access.vue?vue&type=style&index=0&id=9fc22d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc22d2e",
  null
  
)

export default component.exports